// Redux Actions Types
import { SET_SETTINGS } from './types';

export const setSettings = payload => ({
  type: SET_SETTINGS,
  payload,
});


export const fetchSettings = (callback = () => {}) => (dispatch) => {
  // SettingAccess.get().then((settings) => {
    window.backendURL = process.env.REACT_APP_API_URL;
    window.pathEnvironment = process.env.REACT_APP_API_PATH;
    window.jotformUrl = process.env.REACT_APP_JOTFORM_PROFILE_URL;
    window.paymentUrl = "";
    return callback();
};
